import { TextField } from '@calendly/ui/form/text-field'
import { forwardRef, useEffect } from 'react'

import { useDebounce, useDebounceImmediate } from 'hooks/useDebounce'

export const SearchField = forwardRef(({
  onSearchStarted,
  onSearch,
  value,
  ...params
}, ref) => {
  const debouncedQuery = useDebounce(value, 300)
  useEffect(() => {
    if (onSearch) onSearch(debouncedQuery)
  }, [onSearch, debouncedQuery])

  const immediateDebouncedQuery = useDebounceImmediate(value, 300)
  useEffect(() => {
    if (onSearchStarted) onSearchStarted(immediateDebouncedQuery)
  }, [onSearchStarted, immediateDebouncedQuery])

  return (
    <TextField
      ref={ref}
      value={value}
      {...params}
    />
  )
})
